/** ----------------------------------------
    Node Modules
 ---------------------------------------- */

import anime from 'animejs';

/** ----------------------------------------
    Reveal
 ---------------------------------------- */

const defaultReveal = (el, duration = 650, delay = 0) => {
    const height = el.offsetHeight * 0.25;

    return new Promise((resolve) => {
        anime({
            targets: el,
            opacity: [0, 1],
            translateY: [50, 0],
            scale: [0.975, 1],
            duration: duration,
            delay: delay,
            easing: 'easeOutQuad',
            complete: () => resolve()
        });
    });
};

const collageReveal = (el, duration = 500, delay = 0) => {
    const images = el.querySelectorAll('.collage-block__image');

    return new Promise((resolve) => {
        anime({
            targets: images,
            opacity: [0, 1],
            scale: [0.9, 1],
            duration: duration,
            delay: anime.stagger(100),
            easing: 'easeOutQuad',
            complete: () => resolve()
        });
    });
};

const parallaxReveal = (el, duration = 500, delay = 0) => {
    const images = el.querySelectorAll('.parallax-block__image');

    return new Promise((resolve) => {
        anime({
            targets: images,
            opacity: [0, 1],
            duration: duration,
            delay: anime.stagger(75),
            easing: 'easeOutQuad',
            complete: () => resolve()
        });
    });
};

/** ----------------------------------------
    Export Modules
 ---------------------------------------- */

export {
    defaultReveal,
    collageReveal,
    parallaxReveal
};